import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  adminSettings: null,
  attendeeSettings: null
}

const getters = {
  getAdminSettings: state => state.adminSettings,
  getAttendeeSettings: state => state.attendeeSettings
}

const actions = {
  async fetchAdminSettings ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.emailNotificationSettings.getAdminNotificationSettings())
      commit(types.SET_ADMIN_NOTIFICATION_SETTINGS, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to get notification settings')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateAdminSettings ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.emailNotificationSettings.updateAdminNotificationSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Notification settings were successfully updated!')
    } catch (err) {
      if (err.response.data.Code === 'validation.base-0001') {
        commit(types.CREATE_ERROR_MESSAGE, 'The data you try to send is invalid! Check if you filled all the fields and input valid emails')
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Failed to update notification settings')
      }
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchAttendeeSettings ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.emailNotificationSettings.getAttendeeNotificationSettings())
      commit(types.SET_ATTENDEE_NOTIFICATION_SETTINGS, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to get notification settings')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateAttendeeSettings ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.emailNotificationSettings.updateAttendeeNotificationSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Notification settings were successfully updated!')
    } catch (err) {
      if (err.response.data.Code === 'validation.base-0001') {
        commit(types.CREATE_ERROR_MESSAGE, 'The data you try to send is invalid! Check if you filled all the fields and input valid emails')
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Failed to update notification settings')
      }
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_ADMIN_NOTIFICATION_SETTINGS] (state, { settings }) {
    state.adminSettings = settings
  },
  [types.SET_ATTENDEE_NOTIFICATION_SETTINGS] (state, { settings }) {
    state.attendeeSettings = settings
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/emailNotificationSettings.js